const PATH_SEGMENT_REGEX = /([^/]+)/g;
const routeTranslations = __obj('routes');

// Replicate behaviour of RoutingFilter::Translation
export function translate(path: string): string {
  return path.replace(PATH_SEGMENT_REGEX, (segment: string) => {
    // The catalogue is inlined from `config/locales/<locale>/routes.yml`. A
    // segment it does not name, or names as null, stands for itself, as
    // `I18n.t`'s `default:` has it in Rails. Any other single value goes into
    // the path as text, as Rails writes it, so the path built here is the one
    // the server builds: an empty translation empties the segment, and a
    // number reads as its digits. A nested table or a list is the one kind of
    // entry read differently: Rails would write its `inspect` into the path,
    // and the segment stands for itself instead.
    const translated = routeTranslations[segment];

    return typeof translated === 'string' ||
      typeof translated === 'number' ||
      typeof translated === 'boolean'
      ? String(translated)
      : segment;
  });
}
